import {
  request,
  METHOD
} from '@/utils/request.js'


// 自动模式保存
export function save(data) {
  return request(
    '/h5Mfitness/device/save',
    METHOD.POST,
    data
  )
}
// 手动模式保存
export function saveToo(data) {
  return request(
    '/h5Mfitness/device/saveToo',
    METHOD.POST,
    data
  )
}

// 列表
export function getFlowableSchoolCorxInfoList(data) {
  return request(
    '/h5Mfitness/device/getFlowableSchoolCorxInfoList',
    METHOD.POST,
    data
  )
}
// 列表
export function getFlowableSchoolCorxInfoTimeList(data) {
  return request(
    '/h5Mfitness/device/getFlowableSchoolCorxInfoTimeList',
    METHOD.POST,
    data
  )
}

// 设备列表
export function selectSchoolDeviceList(data) {
  return request(
    '/h5Mfitness/deviceH5Fitness/selectSchoolDeviceList',
    METHOD.POST,
    data
  )
}
// 查询设备状态
export function selectSchoolDeviceStatus(data) {
  return request(
    '/h5Mfitness/deviceH5Fitness/selectSchoolDeviceStatus',
    METHOD.POST,
    data
  )
}


// 切换设备项目接口
export function chooseDeviceProject(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/chooseDeviceProject',
    METHOD.POST,
    data
  )
}
// 设置设备时间段项目
export function setWeekDeviceInfo(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/setWeekDeviceInfo',
    METHOD.POST,
    data
  )
}
// 查看每周计划
export function selectWeekDeviceInfo(data) {
  return request(
    'h5Mfitness/deviceH5Fitness/selectWeekDeviceInfo',
    METHOD.POST,
    data
  )
}

// 查看单个项目的配置
export function selectConfigurationByHwp(data) {
  return request(
    '/web/admin/deviceInfo/selectConfigurationByHwp',
    METHOD.GET,
    data
  )
}
// 添加项目配置
export function selectProjectByHwp(data) {
  return request(
    '/web/admin/deviceInfo/selectProjectByHwp',
    METHOD.POST,
    data
  )
}

export function insertConfigurationByHwp(data) {
  return request(
    '/web/admin/deviceInfo/insertConfigurationByHwp',
    METHOD.POST,
    data
  )
}
// 获取图片

export function showYTBase64(data) {
  return request(
    '/web/admin/deviceInfo/showYTBase64',
    METHOD.POST,
    data,
    {
      hideLoading:true
    }
  )
}




